import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './node.types';
import * as constants from './node.constants';

export const storeNode = generateStoreResourceAction<types.IOrganizationChartNode>(constants.STORE_NODE);
export const clearNode = generateClearResourceAction(constants.CLEAR_NODE);
